import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { Group } from '@/views/dashboard/_type/group'

export interface TerminalGroupReq {
  team_id: number,
  /** 登录状态,1-在线,2-离线 */
  login_status?: number
  /** 策略类型 1-安全防护策略 2- 软件禁用策略，不传默认是1 */
  strategy_type?: number
  /** 系统类型, 0-全部,1-windows,2-linux */
  system_type?: number
  /** 系统类型,1-windows,2-linux, 3-Windows server */
  system_types?: number[]
  permission_name?: string
}

export interface TerminalGroupRes {
  /** 终端分组 */
  group: Group
}

@Injectable()
export class GroupEditService {
  constructor (private http: Http) {
  }

  getTerminalGroup (data: TerminalGroupReq) {
    return this.http.post<TerminalGroupRes>('/terminal-group/team-list', data)
  }

  getGroupAndChildrenIds (treeData, targetGroupId) {
    const result = []

    function collectIds(node) {
      result.push(node.group_id)
      if (node?.children?.length) {
        node.children.forEach((child) => collectIds(child))
      }
    }

    function searchNode(node) {
      if (+node.group_id === +targetGroupId) {
        collectIds(node)
        return true
      }
      if (node?.children?.length) {
        for (const child of node.children) {
          if (searchNode(child)) {
            return true
          }
        }
      }
      return false
    }

    searchNode(treeData)

    return result
  }
}
